<template>
    <span :class="{'text-success': value >= 0 && color, 'text-danger': value < 0 && color}">
        <template v-if="value > 0">+</template>{{value|price}}
    </span>
</template>

<script>
    export default {
        name: "price",
        props: {
            value: {
                type: Number,
                required: true
            },
            color: {
                type: Boolean,
                required: false,
                default: true
            },
        }
    }
</script>

<style scoped>

</style>